import { Palette } from "lucide-react";
import SettingSection from "./SettingSection";
import ToggleSwitch from "./ToggleSwitch";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const THEME_KEY = "theme"; // 'dark' | 'light'

function applyThemeClass(mode) {
  const root = document.documentElement; // <html>
  root.classList.toggle("dark", mode === "dark");
}

function getInitialMode() {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === "dark" || saved === "light") return saved;
  // Fallback: préférence OS
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
  return prefersDark ? "dark" : "light";
}

const ThemeMode = () => {
  const { t } = useTranslation();
  const [isDarkMode, setIsDarkMode] = useState(true);

  // Init au montage
  useEffect(() => {
    const mode = getInitialMode();
    setIsDarkMode(mode === "dark");
    applyThemeClass(mode);
  }, []);

  // Sync inter-onglets
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === THEME_KEY && (e.newValue === "dark" || e.newValue === "light")) {
        applyThemeClass(e.newValue);
        setIsDarkMode(e.newValue === "dark");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggleDarkMode = () => {
    const newMode = isDarkMode ? "light" : "dark";
    setIsDarkMode(!isDarkMode);
    localStorage.setItem(THEME_KEY, newMode);
    applyThemeClass(newMode);
    window.location.reload();
  };

  return (
    <SettingSection icon={Palette} title={t("pages.settings.theme")} isDarkMode={isDarkMode}>
      <ToggleSwitch
        label={<span className={isDarkMode ? "text-white" : "text-black"}>{t("pages.settings.dark_mode")}</span>}
        isOn={isDarkMode}
        onToggle={toggleDarkMode}
      />
    </SettingSection>
  );
};

export default ThemeMode;
